import { HAStorePlugin } from "@k4connect/project-merlin-shared-home-automation";

const homeAutomation = HAStorePlugin();
console.log("Store plugin", { HAStorePlugin, homeAutomation });

export { homeAutomation };
